import React from 'react'
import { ProgressChart } from 'Components/Pages/Impact/GoalPage/ProgressChart/ProgressChart'
import { Goal } from 'Generated/graphql-types'
import { Box } from '@material-ui/core'
import { GoalPageHeader, GoalPageSubHeader } from './FunderGoal.styled'
import { GoalSharedToFunderCard } from '../GoalSharedToFunderCard'
import { GOAL_PAGE_SUBHEADER_TEXT } from '../utils'

type GoalSharedToFunderProps = {
  goal: Goal
  targetProgress: number
}

export const GoalSharedToFunder = ({
  goal,
  targetProgress,
}: GoalSharedToFunderProps) => {
  if (!goal) {
    return null
  }

  return (
    <>
      <Box>
        <GoalPageHeader>Goal Overview</GoalPageHeader>
        <GoalPageSubHeader>{GOAL_PAGE_SUBHEADER_TEXT}</GoalPageSubHeader>
      </Box>
      <GoalSharedToFunderCard
        isInteractive={false}
        goal={goal}
        targetProgress={targetProgress}
      />
      <ProgressChart goal={goal || []} isGoalSharedWithFunder />
    </>
  )
}
